import { Globe } from 'lucide-react';

import { numberFormat } from '../../pages/weeklyreport/format';
import { type weeklyreportDomainRow } from '../../services/api/weekly-report';

interface DomainBreakdownProps {
  rows: weeklyreportDomainRow[];
  withoutDomain: number;
}

export const DomainBreakdown = ({ rows, withoutDomain }: DomainBreakdownProps) => (
  <>
    {rows.length === 0 ? (
      <p className="text-sm text-slate-500">Ingen domäninformation denna vecka.</p>
    ) : (
      <ul className="space-y-1">
        {rows.map((row) => (
          <li
            key={row.domain}
            className="flex items-center justify-between border-b border-slate-100 py-2 last:border-0"
          >
            <span className="flex items-center gap-2">
              <Globe className="h-4 w-4 text-slate-400" />
              {row.domain}
            </span>
            <span className="font-medium">{numberFormat.format(row.count)}</span>
          </li>
        ))}
      </ul>
    )}
    {withoutDomain > 0 && (
      <p className="mt-2 text-sm text-slate-500">
        {numberFormat.format(withoutDomain)} chattar utan domän (mejl har ingen sida).
      </p>
    )}
  </>
);
